import React from 'react';
import { useTextSelectionAI } from '../hooks/useTextSelectionAI';

interface GlobalTextSelectionAIProps {
  enabled?: boolean;
}

/**
 * Global Text Selection AI Component
 * 
 * Add this component once at the root of your app to enable
 * AI text editing anywhere in your application.
 * 
 * Usage:
 * ```tsx
 * <GlobalTextSelectionAI />
 * ```
 * 
 * Now any textarea or input field can be edited with AI by:
 * 1. Highlighting text
 * 2. Clicking the blue AI button
 * 3. Describing the change
 */
export function GlobalTextSelectionAI({ enabled = true }: GlobalTextSelectionAIProps) {
  const { renderUI } = useTextSelectionAI({ enabled });
  
  return <>{renderUI()}</>;
}

